/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type { SyncQueryResponse, Sync401 } from "../types/Sync.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { sync } from "../client/sync.ts"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const syncQueryKey = () => [{ url: "/sync" }] as const

export type SyncQueryKey = ReturnType<typeof syncQueryKey>

export function syncQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = syncQueryKey()
  return queryOptions<
    SyncQueryResponse,
    ResponseErrorConfig<Sync401>,
    SyncQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return sync(config)
    },
  })
}

/**
 * @summary Sync user data
 * {@link /sync}
 */
export function useSync<
  TData = SyncQueryResponse,
  TQueryData = SyncQueryResponse,
  TQueryKey extends QueryKey = SyncQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        SyncQueryResponse,
        ResponseErrorConfig<Sync401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? syncQueryKey()

  const query = useQuery(
    {
      ...syncQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Sync401>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
